import {
  Component,
  ElementRef,
  HostListener,
  ViewChild,
  AfterViewInit,
  OnInit,
  CUSTOM_ELEMENTS_SCHEMA,
  AfterViewChecked,
  PLATFORM_ID,
  inject,
  NgZone,
} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HttpClient,
  HttpClientModule,
  HttpHeaders,
} from '@angular/common/http';
import swal from 'sweetalert2';
import { ApidataService } from '../apidata.service';
import { response } from 'express';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterLink } from '@angular/router';
import { RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { RecaptchaModule, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { ChangeDetectorRef } from '@angular/core';
import { environment, GINConstants } from '../../environments/environments';
import { FeedbackComponent } from '../feedback/feedback.component';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import { QuillModule } from 'ngx-quill';
import Quill from 'quill';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { Inject } from '@angular/core';
import { LanderComponent } from '../grammarchecker/additional/lander.component';
import { PremiumComponent } from "../premium/premium.component";
import { PremiumModalStartupComponent } from '../premium-modal/premium-modal.component';
import { HeaderComponent } from '../header/header.component';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { SeoTagsService } from '../services/seo-tags.service';
import {
  SUPPORTED_LANGUAGES,
  DEFAULT_LANGUAGE,
} from '../config/language.config';
import { NavigationStart } from '@angular/router';
import { LinkService } from '../services/link.service';

declare var Dropbox: any;
declare var $: any;
declare var window: any;
declare var google: any;
declare var gapi: any;

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    HeaderComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FooterComponent,
    NgbAccordionModule,
    RouterModule,
    RecaptchaModule,
    FeedbackComponent,
    IconsFreeToolsComponent,
    QuillModule,
    LanderComponent,
    PremiumComponent,
    PremiumModalStartupComponent,
    TranslateModule,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
  providers: [ApidataService],
})
export class HomeComponent implements OnInit, AfterViewInit {
  private platformId = inject(PLATFORM_ID);
  private ngZone = inject(NgZone);

  isUserLoggedin: boolean = false;
  authentication_token;
  user;
  idgoogle;
  price_id;
  recaptcha_message = '';
  got_recpatcha: boolean = false;
  recaptchaSiteKey = '6LcMnOsnAAAAAExxnt0IqIEq4pSha6O_vPeOsw-1';
  captchaResponse: string;
  public clientId =
    '859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com';
  public scope = [
    'profile',
    'email',
    'https://www.googleapis.com/auth/drive.file',
  ].join(' ');
  showbuttons: boolean = false;
  gotresponse: boolean = false;

  // SCROL
  shouldShowButton: boolean = false;
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.shouldShowButton = true;
    } else {
      this.shouldShowButton = false;
    }
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  selectedValue: number;

  @ViewChild('editor') editor: ElementRef;
  //
  public form_message: any;
  public form_email: any;
  public showfeedbackloader: boolean = false;
  eFsubText2: any;
  public eFsubIF: boolean = false;
  dangerAlerts;

  ifsub: boolean = false;

  //
  @ViewChild('tooltiphomeButtonModalbefore') openModal: ElementRef;
  public settargetvalue: boolean = true;
  public forgotPassword: boolean = false;
  public showSignInDialog = false;
  public showSignUpDialog = false;
  public copiedtext: boolean = false;
  public showonlydrive: boolean = false;
  public loaderAlert: boolean = false;
  public menuafterresponse: boolean = false;
  public isSearchingformodel = false;
  success: boolean = false;
  showParagraph: boolean = true;
  public eFsub: boolean = false;
  public eFsuberror: boolean = false;
  isExport: boolean = false;
  error: boolean = false;
  popupVisible = false;
  matchVisible = false;
  modelVisble = false;
  matchReplacement: boolean = false;
  public openpopup: boolean = false;
  public copylinkture: boolean = false;
  selectuslanaguge: boolean = true;
  selectuklanague: boolean = false;
  selectcalanaguage: boolean = false;
  selectaulanaguge: boolean = false;
  hovered: boolean = false;
  public checkLogin = false;
  public intentbtn: boolean = true;
  public describebtn: boolean = false;
  public conviencebtn: boolean = false;
  public tellbtn: boolean = false;

  isTextAreaFocused: boolean = false;
  showError: boolean = false;

  captchaToken: string | null = null;

  public logintext: string = '';
  public signuptext: string = '';
  public color: string = 'black';
  public esubText: string = '';
  public esubText2: string = '';
  public copried_txt: string = '';
  public docTitle2 = '';
  public responsetext = '';
  public fptext = '';
  public clipboardtext = '';
  public homeText = '';
  public doc_id = '';
  public cookieValue = '';
  public facebookResponse = '';
  sanitizedText: string = '';
  public lang = 'en-US';
  popupWidth: string = '360px';
  selectedplan = '';
  selectedplanaoumt = '';

  public myForm: FormGroup;
  public myForm2: FormGroup;
  public inHandIssues = 0;
  public finalSum = 0;
  public spellfinalSum = 0;
  public spellingsum = 0;
  public previouslengthformodel = 0;
  public BRformodel = 0;
  public previouslength = 0;
  public googledriveword = 0;
  public spellingmistake = 0;
  public garmmarmistake = 0;
  selectedParagraph: number = 1;

  public get_socket_object;
  public isSearching;
  public editorWidth;
  public BR;
  about_us;
  docTitle;
  profile_id;
  public char_count;
  word_count;
  public data1;
  public popupSpace;
  public storeparentid;
  public storeparentid2;
  errorAlerts;
  successAlert;
  premium_user_done;
  countcustomizedresponse;

  popupPosition: any;
  modelCorrect: any;
  public auth2: any;
  modelChkiD: any;
  activeElement: HTMLElement | null = null;
  elementId: any;
  elementIdParts: any;
  targetHTMLElement: any;
  wordCount: any;
  modelChkiD_background: any;
  orignalWordMatch: any;
  descriptionMatch: any;
  activeElement_ruleid: any;
  public form_name: any;
  public form_lastname: any;
  public form_messageget: any;
  public form_emailget: any;
  eFsubText: any;

  innerTextArray: string[] = [];
  gotgrammarmistake = [];
  gotspellingmistake = [];
  public dataListing: any[] = [];
  public dataListingFinal: any[] = [];
  public matchesArray = [];
  public all_grammar_mistakes = [];
  public new_chunk_list = [];
  popupSynonyms: string[] = [];
  public filterlistarrayrecord = [];

  recaptchaWidgetId: number | undefined;

  constructor(
    private cdr: ChangeDetectorRef,
    private httpClient: ApidataService,
    private https: HttpClient,
    private router: Router,
    private meta: Meta,
    private titleService: Title,
    private zone: NgZone,
    private cd: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private languageService: LanguageService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private linkService: LinkService,
    private seoService: SeoTagsService
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  }

  @ViewChild('fileInput') fileInput;

  navigatetoopenfile() {
    this.router.navigate(['/openfile']);
    window.location.reload;
  }
  reloadPage() {
    window.location.reload();
  }
  public pickerApiLoaded = false;
  public oauthToken?: any;
  selectedPlan: any = 'Quarterly';
  hoveredPlan: string | null = null;

  onHover(plan: string): void {
    this.selectedPlan = plan;
  }

  onLeave(): void {
    this.selectedPlan = 'Quarterly';
  }

  onSelect(plan: string): void {
    this.selectedPlan = plan;
  }
  @ViewChild('text') textDivRef!: ElementRef;
  @ViewChild('placeholderSpan') placeholderSpanRef!: ElementRef;
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    const textDiv = this.textDivRef?.nativeElement;
    const span = this.placeholderSpanRef?.nativeElement;
    if (textDiv && (textDiv.contains(target) || span?.contains(target))) {
      this.isTextAreaFocused = true;
    }
  }

  onFocus(): void {
    this.isTextAreaFocused = true;
  }
  onclickeditors(event: MouseEvent): void {
    this.isTextAreaFocused = true;
  }

  onInput(): void {
    this.isTextAreaFocused = true;
  }

  onSpanClick(): void {
    this.textDivRef.nativeElement.focus();
    this.isTextAreaFocused = true;
  }

  onButtonClick(): void {
    this.isTextAreaFocused = true;
  }

  public placeholderText(event) {
    if (event == '1') {
      $('#placHdlrTxt').html('Enter Your Text Here');
    } else {
      $('#placHdlrTxt').html('');
    }
  }

  deleteText() {
    $('.ql-editor').html('');
    this.loaderAlert = true;

    if (this.quill) {
      this.quill.setContents([]);
    }

    this.homeText = '';
    this.word_count = 0;
    this.char_count = 0;

    this.showParagraph = true;
    this.loaderAlert = false;
  }
  selectParagraphHeading: string = 'Check Grammar Mistakes';
  selectParagraphText: string =
    'You can make your text grammatically sound with the help of our grammar fixer. It even highlights the words or phrases that don’t fit the context of your article. This English corrector can spot all kinds of grammar mistakes from issues in subject-verb agreement to verb tense problems.';
  selectParagraphImage: string =
    '../../assets/images/homepage/Common Writing Mistakes/Check Grammar Mistakes.svg';
  paragraphs = [
    {
      heading: 'Check Grammar Mistakes',
      text: 'You can make your text grammatically sound with the help of our grammar fixer. It even highlights the words or phrases that don’t fit the context of your article. This English corrector can spot all kinds of grammar mistakes from issues in subject-verb agreement to verb tense problems.',
      image:
        '../../assets/images/homepage/Common Writing Mistakes/Check Grammar Mistakes.svg',
    },
    {
      heading: 'Incorrect Singular/Plural Nouns',
      text: 'To communicate effectively, proper agreement between singular and plural nouns and their associated verbs and pronouns is essential. Our grammar checker allows you to identify and correct instances where this agreement is incorrect.',
      image:
        '../../assets/images/homepage/Common Writing Mistakes/Incorrect Singular Plural Nouns.svg',
    },
    {
      heading: 'Eliminate Wrong Spelling',
      text: 'Spelling mistakes might seem childish, but many people make typos while being fully involved in jotting down words. However, you must pay attention to spelling mistakes, as they make your writing appear unprofessional. Its spell checker feature spots the incorrect spellings in your text and provides suitable recommendations to fix them.',
      image:
        '../../assets/images/homepage/Common Writing Mistakes/Eliminate Wrong Spelling.svg',
    },
    {
      heading: 'Fix Capitalization Issues',
      text: 'If your writing contains incorrect or inconsistent capitalization, it wont be able to bypass the fast detection of our AI grammar checker. Whether its the beginning of an article, proper nouns, or specific topics, our English corrector carefully corrects these mistakes.',
      image:
        '../../assets/images/homepage/Common Writing Mistakes/Fix Capitalization Issues.svg',
    },
    {
      heading: 'Subject Verb Agreement',
      text: 'Subject-verb agreement by our text corrector is vital in refining written content. The correct agreement between the subject and verb is paramount for clear and effective communication. Our English correction facility meticulously examines content, verifying that subjects and verbs align in number and person. If discrepancies are detected, the tool promptly suggests corrections, ensuring grammatical accuracy throughout the text.',
      image:
        '../../assets/images/homepage/Common Writing Mistakes/Subject Verb Agreement.svg',
    },
    {
      heading: 'Word Order',
      text: 'In grammar, "word order" refers to the specific order in which words are placed to form a structured and meaningful sentence. A simple sentence in Standard English follows the Subject + Verb + Object (SVO) rule. Different languages ​​have their own rules regarding word order, and adherence to these rules is essential to convey a sentences intended meaning accurately.',
      image:
        '../../assets/images/homepage/Common Writing Mistakes/Word Order.svg',
    },
    {
      heading: 'Fix Punctuation Errors',
      text: 'To communicate effectively, proper agreement between singular and plural nouns and their associated verbs and pronouns is essential. Our grammar checker allows you to identify and correct instances where this agreement is incorrect.',
      image:
        '../../assets/images/homepage/Common Writing Mistakes/Fix Punctuation Errors.svg',
    },
    {
      heading: 'Improve Sentence Structure',
      text: 'Besides enhancing the quality of an entire article, GrammarIn also allows you to improve the structure of individual sentences. If your sentences are vague or contain faulty parallelism, then our sentence checker will smartly identify these mistakes and help you enhance their readability.',
      image:
        '../../assets/images/homepage/Common Writing Mistakes/Fix Punctuation Errors-1.svg',
    },
  ];

  selectParagraph(paragraphNumber: number) {
    this.selectedParagraph = paragraphNumber;
    this.selectParagraphHeading = this.paragraphs[paragraphNumber - 1].heading;
    this.selectParagraphText = this.paragraphs[paragraphNumber - 1].text;
    this.selectParagraphImage = this.paragraphs[paragraphNumber - 1].image;
  }

  selectParagraphMobile(event: Event) {
    const selectedValue = +(event.target as HTMLSelectElement).value;
    this.selectedParagraph = selectedValue;
    this.selectParagraphHeading = this.paragraphs[selectedValue - 1].heading;
    this.selectParagraphText = this.paragraphs[selectedValue - 1].text;
  }
  selectKeyFeaturesText: string =
    "Our online grammar checker is a 100% free-of-cost tool. You don't need to worry about burdening your pocket to use this facility. It doesn't have any hidden charges and gives you the freedom to check grammar from unlimited pieces of content.";
  keyFeatures = [
    {
      text: "Our online grammar checker is a 100% free-of-cost tool. You don't need to worry about burdening your pocket to use this facility. It doesn't have any hidden charges and gives you the freedom to check grammar from unlimited pieces of content.",
    },
    {
      text: 'Grammarin.com is a pedagogical rostrum where learner and teachers get benefit from hundreds of professional writers to assist them with their writing assignments.',
    },
    {
      text: 'What makes students trust our services? Unprecedented professionalism: We brag a core of executive writers who have passed four stages of the hiring process to certify a high level of competence and credibility.',
    },
    {
      text: 'Grammarin.com automatically checks your punctuation, grammatical errors, spelling errors, word choices, and style mistakes in your writing.',
    },
    {
      text: 'Millions of writers worldwide trust Grammarin.com because Grammarin helps the students to achieve their academic goals and improve their writing in essays, reports, theses, dissertations, and college entrance applications.',
    },
  ];
  selectKeyFeaturesMobile(event: Event) {
    const selectedValue = +(event.target as HTMLSelectElement).value;
    this.selectKeyFeaturesText = this.keyFeatures[selectedValue - 1].text;
  }
  uploadFileSaveRedirect(event): void {
    const files: FileList = this.fileInput.nativeElement.files;
    var filetype = 'pdf';
    if (files[0].size > 5243000) {
      // this.showAlert('File should be less than 5 MB', '');
      this.translate
        .get('alerts.fileSizeLimit')
        .subscribe((translatedMsg: string) => {
          this.showAlert(translatedMsg, '');
        });
    } else {
      let input = event.target;
      this.menuafterresponse = false;
      this.gotresponse = false;
      this.loaderAlert = true;
      this.showParagraph = true;
      this.char_count = 0;
      this.showbuttons = false;

      $('.hideUpload').hide('slow');
      this.httpClient.uploadfilefrombrowser(files).subscribe(
        (data) => {
          this.loaderAlert = false;

          let receivedData = data;
          $('.ql-editor').html(
            receivedData['RetCnt']
              .replace(/&quot;/g, '"')
              .replace(/&#x27;/g, "'")
              .replace(/&amp;/g, /&/g)
              .replace(/&gt;/g, '>')
              .replace(/&lt;/g, '<')
              .replace(/&quot;/g, /"/g)
              .replace(/\n/g, '<br>')
          );
          this.getContent('', receivedData['RetCnt']);

          this.char_count = $('#editor').text().length;
          // this.homeText = $('#editor').text();
          this.word_count = $('#editor').text().split(/\s+/).length;

          this.fileInput.nativeElement.value = '';
        },
        (error) => {
          this.loaderAlert = false;
          // this.showAlert(
          //   'Unable to proceed with a password protected file',
          //   ''
          // );
          this.translate
            .get('alerts.Unable-to-proceed')
            .subscribe((translatedMsg: string) => {
              this.showAlert(translatedMsg, '');
            });
        }
      );
    }
  }

  onclickeditor(event: MouseEvent) {
    this.homeText = this.quillEditor.root.innerHTML;
    this.char_count = this.quillEditor.getText().trim().length;
    this.word_count = this.quillEditor
      .getText()
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;
    event.stopPropagation();
    if (this.char_count === 0 && !this.showParagraph) {
      this.word_count = 0;
      this.char_count = 0;
    }
    this.showParagraph = false;
    // const sampleText = 'Enter your Text HereORUpload file from above options';
    const sampleText = this.translate.instant('alerts.Enter-Text');
    const editorContent = $('#editor').text().trim();
    if (editorContent === sampleText) {
      this.word_count = 0;
      this.char_count = 0;
    }
    if (editorContent === '') {
      this.word_count = 0;
      this.char_count = 0;
    } else {
      this.word_count = editorContent
        .split(/\s+/)
        .filter((word) => word.length > 0).length;
    }
  }
  selectedLanguage: any;
  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        let url = event.url;

        if (url !== '/' && url.endsWith('/')) {
          url = url.slice(0, -1);
          this.router.navigateByUrl(url);
          return;
        }

        if (url === '/' || url === '') {
          const selectedLang = this.selectedLanguage?.code || 'en';
          if (selectedLang !== 'en') {
            this.router.navigateByUrl(`/${selectedLang}`);
          }
        }
      }
    });

    // const isMobile = window.innerWidth <= 600;

    // if (isMobile) {
    //   this.router.navigate(['/app-home']);
    // } else {
    //   this.router.navigate(['/']);
    // }

    this.wordCounter();
    this.onInput();

    this.char_count = $('#editor').text().length;
    this.word_count = $('#editor').text().split(/\s+/).length;

    setTimeout(() => {
      $('#editor').on('input paste', (event: any) => {
        let editorContent = $('#editor').text().trim();

        this.zone.run(() => {
          this.word_count = editorContent
            .split(/\s+/)
            .filter((word) => word.length > 0).length;
          this.char_count = editorContent.length;
        });
      });
    }, 0);





    const langCode = this.languageService.selectedLanguage?.code || 'en';
    if (this.languageService.selectedLanguage?.code != 'en') {
      const canonicalUrl = `https://www.grammarin.com/${langCode}`;
      this.seoService.setCanonicalUrl(canonicalUrl);
    }
    this.seoService.updatePageMeta('meta-data-Home');

    // Ahref Langs
    this.linkService.addAlternateLink('x-default', 'https://www.grammarin.com');
    this.linkService.addAlternateLink('en', 'https://www.grammarin.com');
    this.linkService.addAlternateLink('pt', 'https://www.grammarin.com/pt');
    this.linkService.addAlternateLink('es', 'https://www.grammarin.com/es');
    // Ahref Langs 

    this.languageService.selectedLanguage$.subscribe((language) => {
      this.selectedLanguage = language;
      this.translate.use(language.code);
    });

    this.activeTab = 'q5';
    this.profile_id = localStorage.getItem('profile_id');
    if (!this.profile_id) {
      this.profile_id = '1';
      this.isUserLoggedin = false;
    } else {
      this.isUserLoggedin = true;
    }
    const storedStatus = JSON.parse(
      localStorage.getItem('premium_user_done') || 'false'
    );
    this.premium_user_done = storedStatus;
  }


  ////// hidden recaptcha strat

  captchaVisible: boolean = false;
  isCaptchaVerified: boolean = false;
  recaptchaMessage: string = '';

  handleButtonClick(): void {
    setTimeout(() => {
      // if (this.homeText.length > 0) {
      const editorElement = document.querySelector('.ql-editor');
      if (editorElement.textContent.trim().length > 0) {
        // console.log('editorElement', editorElement);

        if (this.isCaptchaVerified) {
          this.saveTextRedirect('grammar');
        } else {
          if (!this.captchaVisible) {
            this.captchaVisible = true;
            this.cdr.detectChanges();
            this.loadAndRenderTurnstile();
          } else {
            this.recaptchaMessage = 'Please complete the CAPTCHA.';
            this.color = '#721c24';
          }
        }
      } else {
        // this.showAlert('Please enter 1 word to proceed.', '');
        this.translate
          .get('alerts.Please-add')
          .subscribe((translatedMsg: string) => {
            this.showAlert(translatedMsg, '');
          });
      }
    }, 50);
  }

  loadAndRenderTurnstile(): void {
    if (typeof window['turnstile'] === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => this.renderTurnstile();
      script.onerror = () => console.error('Failed to load Turnstile script.');
      document.body.appendChild(script);
    } else {
      this.renderTurnstile();
    }
  }

  renderTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (!containerElement) {
      console.error('Container element not found.');
      return;
    }

    window['turnstile'].render(containerElement, {
      sitekey: environment.CaptchaKey,
      size: 'normal',
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });
    // console.log('Turnstile rendered successfully.');
  }

  onTurnstileSuccess(token: string): void {
    // console.log('Turnstile token received:', token);
    this.captchaToken = token;
    this.isCaptchaVerified = true;
    this.captchaVisible = false;
    this.recaptchaMessage = '';
    this.saveTextRedirect('grammar');
  }

  onTurnstileError(): void {
    console.error('Turnstile error occurred.');
    this.captchaToken = null;
    this.recaptchaMessage = 'CAPTCHA verification failed. Please try again.';
    this.color = '#721c24';
  }

  resetTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (typeof window['turnstile'] !== 'undefined') {
      window['turnstile'].reset(containerElement);
      // console.log('Turnstile CAPTCHA reset.');
    } else {
      console.error('Turnstile library not loaded.');
    }
  }

  ///// recaptcha end

  countWordsUsingRegex(text: string): number {
    if (!text) {
      return 0;
    }
    const words = text.trim().match(/\b\w+\b/g);
    return words ? words.length : 0;
  }
  spanVisible: boolean = true;
  updateWordCount(): void {
    this.word_count = this.countWordsUsingRegex(this.homeText);
    this.char_count = this.homeText.length;
    this.spanVisible = this.homeText.trim().length === 0;
  }
  activeTab: string = '';

  toggleTab(tabId: string): void {
    if (this.activeTab === tabId) {
      this.activeTab = '';
    } else {
      this.activeTab = tabId;
    }
  }

  filterstatus = '';
  subscribed_user;

  count_Words_Character2() {
    this.char_count = this.quillEditor.getText().trim().length;
    this.word_count = this.quillEditor
      .getText()
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;
    this.char_count = $('.ql-editor').text().length;
    this.word_count = $('.ql-editor').text().split(/\s+/).length;
  }

  public ngAfterViewInit(): void {
    const langCode = this.languageService.selectedLanguage?.code || 'en';
    if (this.languageService.selectedLanguage?.code != 'en') {
      const canonicalUrl = `https://www.grammarin.com/${langCode}`;
      this.seoService.setCanonicalUrl(canonicalUrl);
    }
    this.seoService.updatePageMeta('meta-data-Home');

    this.char_count = $('#editor').text().length;
    this.homeText = $('#editor').text();
    this.word_count = $('#editor').text().split(/\s+/).length;
    this.wordCounter();
    this.onInput();

    const storedStatus = JSON.parse(
      localStorage.getItem('premium_user_done') || 'false'
    );
    this.subscribed_user = storedStatus;
    this.profile_id = localStorage.getItem('profile_id');
    if (!this.profile_id) {
      this.profile_id = '1';
      this.isUserLoggedin = false;
    } else {
      this.isUserLoggedin = true;
    }

    if (this.captchaVisible) {
      this.loadAndRenderTurnstile();
    }

    this.char_count = $('#editor').text().length;

    this.word_count = $('#editor').text().split(/\s+/).length;

    setTimeout(() => {
      $('#editor').on('input paste', (event: any) => {
        let editorContent = $('#editor').text().trim();

        this.zone.run(() => {
          this.word_count = editorContent
            .split(/\s+/)
            .filter((word) => word.length > 0).length;
          this.char_count = editorContent.length;
        });
      });
    }, 0);

    this.checkLogin = this.httpClient.isLoggedIn();
    if (this.checkLogin) {
      this.profile_id = localStorage.getItem('profile_id');
    } else {
      this.profile_id = '1';
    }

    $('#editor').on('click', function () {
      $('.text-field-placeholder').hide();
      $('#chkGramTxtLimit').hide();
      $('#placHdlrTxt').hide();
    });

    $(document).ready(function () {
      $('#editor').focus();

      $('#editor').keyup(function () {
        $('.text-field-placeholder').hide();
        $('#chkGramTxtLimit').hide();
        var text_length = $('#editor').val().length;
        if (text_length <= 0) {
          $('.text-field-placeholder').show();
        }
      });
      $('.text-field-placeholder').click(function () {
        $('#editor').focus();
      });

      $('#editor').on('click', function () {
        $('.text-field-placeholder').hide();
        $('#chkGramTxtLimit').hide();
      });

      $(window).scroll(function () {
        if ($(this).scrollTop() > 200) {
          $('#scroll-to-top').fadeIn('slow');
        } else {
          $('#scroll-to-top').fadeOut('slow');
        }
      });
      $('#scroll-to-top').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 700);
        return false;
      });

      let secondaryNav = $('nav');

      $('.modal-backdrop').removeClass('modal-backdrop');

      $('.nav>li.active').removeClass('active');
      $('a[href="' + document.URL + '"]')
        .closest('li')
        .addClass('active');

      $('#about-us').click(function () {
        $('html, body').animate(
          {
            scrollTop: $('#row_about').offset().top - 100,
          },
          700
        );
      });
      $('#why-grammar').click(function () {
        $('html, body').animate(
          {
            scrollTop: $('#row_use_gram h3').offset().top - 100,
          },
          700
        );
      });
      $('#why-plagiarism').click(function () {
        $('html, body').animate(
          {
            scrollTop: $('#row_use_plag h3').offset().top - 100,
          },
          700
        );
      });
      $('#tips').click(function () {
        $('html, body').animate(
          {
            scrollTop: $('#row_tips').offset().top - 50,
          },
          700
        );
      });
      $('#support').click(function () {
        $('html, body').animate(
          {
            scrollTop: $('#row_contact').offset().top - 50,
          },
          700
        );
      });

      $('#plaagiarism-tab').click(function () {
        $('#grammar-tab').addClass('btlr_radius');
      });
      $('#grammar-tab').click(function () {
        $('.nav-link').removeClass('btlr_radius');
      });

      let giftofspeed = document.createElement('link');
      giftofspeed.rel = 'stylesheet';
      giftofspeed.href =
        'https://fonts.googleapis.com/css?family=Quicksand:300,400,500,700';
      giftofspeed.type = 'text/css';
      let godefer = document.getElementsByTagName('link')[0];
      godefer.parentNode.insertBefore(giftofspeed, godefer);
    });
  }

  checkUserIdAndRouteplans() {
    this.router.navigate(['/plans']);
  }
  navigateTosignin() {
    this.router.navigate(['/signin']);
  }
  navigateTosignup() {
    this.router.navigate(['/signup']);
  }

  navigateToplans() {
    this.router.navigate(['/plans']);
  }
  countStar(star) {
    this.selectedValue = star;
  }
  public logError(err: Response) {
    if (err.status === 0) {
      // console.error('Seems server is down');
    }
    if (err.status === 401) {
    }
  }

  closepopUpArt() {
    this.activeElement.classList.remove('active');
    this.activeElement.style.backgroundColor = 'white';
    this.popupVisible = false;
  }

  countfunction(text) {
    if (text === '' && !this.showParagraph) {
      const wordcount = 0;
      const charcount = 0;
      this.word_count = 0;
      this.char_count = 0;
    }
  }

  words;
  wordCounter() {
    this.isTextAreaFocused = true;
    this.words = this.wordCount ? this.wordCount.length : 0;
    if (this.words > 0) {
      this.isTextAreaFocused = true;
    }
  }

  public getContent(event, text) {
    this.isTextAreaFocused = false;
    this.showonlydrive = false;
    this.showParagraph = false;
    this.noerrorfound = false;
    var ctrlDown = false,
      ctrlKey = 17,
      cmdKey = 91,
      vKey = 86,
      cKey = 67;
    // this.homeText = text.replace(/\n/g, '<br>');

    if (ctrlDown && event.keyCode == vKey) {
      this.showParagraph = false;
      this.isTextAreaFocused = false;
    }
    var old_text = document.getElementById('editor').textContent;
    if (this.responsetext) {
      if (old_text != this.responsetext) {
        this.loaderAlert = false;
        this.dataListing = [];
        this.dataListingFinal = [];
        this.data1 = [];
        this.new_chunk_list = [];
      }
    }
    var editorcontent = $('#editor');

    // this.homeText = this.quillEditor.root.innerHTML;
    this.char_count = this.quillEditor.getText().trim().length;
    this.word_count = this.quillEditor
      .getText()
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;
  }
  word_character_count() {
    this.homeText = this.quillEditor.root.innerHTML;
    this.char_count = this.quillEditor.getText().trim().length;
    this.word_count = this.quillEditor
      .getText()
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;
  }
  onContentChanged(event: any) {
    this.word_character_count();
  }
  //////////////End fun Get content from Editor on keyup //////////

  ////// start select language

  public countall(object, sum, spellsum) {
    if (object.errors.SpellError > 0) {
      this.gotspellingmistake.push({ errors: object.errors.SpellError });
      this.gotspellingmistake.forEach((item) => {
        spellsum += item.errors;
        this.spellingmistake = spellsum;
      });
    }
    if (object.errors.GrammarError > 0 || object.errors.modelsuggestions > 0) {
      this.gotgrammarmistake.push({
        errors: object.errors.GrammarError + object.errors.modelsuggestions,
      });
      this.gotgrammarmistake.forEach((item) => {
        sum += item.errors;
        this.garmmarmistake = sum;
      });
    }
  }

  //////////////////// for route to dashboard
  convertTablesToParagraphs(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    doc.querySelectorAll('table').forEach((table) => {
      let newParagraphs = '';

      table.querySelectorAll('tr').forEach((row) => {
        let rowText: string[] = [];

        row.querySelectorAll('td, th').forEach((cell) => {
          rowText.push(cell.textContent?.trim() || '');
        });

        newParagraphs += `<p>${rowText.join(' | ')}</p>`;
      });

      const wrapper = document.createElement('div');
      wrapper.innerHTML = newParagraphs;
      table.replaceWith(...Array.from(wrapper.childNodes));
    });

    return doc.body.innerHTML;
  }
  public saveTextRedirect(type) {
    $('#editor').find('span').contents().unwrap();

    this.homeText = this.quillEditor.scroll.domNode.innerHTML;
    // console.log("home tex", this.quillEditor.scroll.domNode.innerHTML )
    setTimeout(() => {
      this.quill.root.querySelectorAll('img').forEach((img) => img.remove());
    }, 0);

    // if (
    //   this.homeText !=
    //   'Upload Your ContentType or Paste AI Text hereSample TextPaste text'
    // )
    const localizedText = this.translate.instant(
      'alerts.Upload-Your-ContentType'
    );
    if (this.homeText !== localizedText) {
      this.char_count = $('#editor').text().length;
      this.word_count = $('#editor').text().trim().split(/\s+/).length;

      const trimmedText = this.homeText.trim();
      if (trimmedText.length === 0) {
        // this.showAlert('Error: Input is empty or only spaces.', '');
        this.translate
          .get('alerts.Input-is-empty')
          .subscribe((translatedMsg: string) => {
            this.showAlert(translatedMsg, '');
          });

        return;
      } else {
        if (this.homeText.length > 0) {
          this.loaderAlert = true;
          let data2 = JSON.stringify({
            homeText: this.convertTablesToParagraphs(this.homeText),
            profile_id: this.profile_id,
          });

          let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';

          this.httpClient.postResources(data2, url).subscribe((data) => {
            let receivedData = data;
            var editortxt = '';
            editortxt = this.convertTablesToParagraphs(this.homeText);

            localStorage.setItem('editorValueAI', editortxt);
            this.doc_id = receivedData['new_doc_id'];

            if (window.innerWidth < 600) {
              this.router.navigate(['/document-lite/', this.doc_id]);
            } else if (window.innerWidth < 868) {
              this.router.navigate(['/document-tab/', this.doc_id]);
            } else {
              this.router.navigate(['/grammar-check'], {
                queryParams: { doc: this.doc_id },
              });
            }

            const url = this.router.serializeUrl(
              this.router.createUrlTree([''])
            );
          });
        }
      }
    } else {
      // this.showAlert('Error: Please add atleast 1 word to proceed.', '');
      this.translate
        .get('alerts.Please-add')
        .subscribe((translatedMsg: string) => {
          this.showAlert(translatedMsg, '');
        });
    }
  }
  public handleNewDocData(data) {
    if (data.status === 200) {
      let receivedData = data.json();

      this.doc_id = receivedData['new_doc_id'];

      this.router.navigate(['/grammar-check'], {
        queryParams: { doc: this.doc_id },
      });
    }
  }

  public gotoeditor(type) {
    let data2 = JSON.stringify({
      homeText: this.homeText,
      profile_id: this.profile_id,
    });
    let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';
    this.httpClient.postResources(data2, url).subscribe((data) => {
      let receivedData = data;

      this.doc_id = receivedData['new_doc_id'];
      this.router.navigate(['/grammar-check'], {
        queryParams: { doc: this.doc_id },
      });
      var editortxt = '';
      editortxt = this.homeText;
      localStorage.setItem('editorValueAI', editortxt);
      const url = this.router.serializeUrl(this.router.createUrlTree(['']));
    });
  }

  ///// google drive for upload file

  countWordsAndCharacters(text: string): void {
    const wordsArray = text.trim().split(/\s+/);
    this.word_count = wordsArray.length;
    this.char_count = text.length;
  }

  public gDriveUpload() {
    this.loaderAlert = true;
    gapi.load('auth', { callback: this.onAuthApiLoad.bind(this) });
    gapi.load('picker', { callback: this.onPickerApiLoad.bind(this) });
    setTimeout(() => {
      $('.ql-editor').click();
    }, 500);
    this.loaderAlert = false;
  }

  public onAuthApiLoad() {
    gapi.auth.authorize(
      {
        client_id: this.clientId,
        scope: this.scope,
        immediate: false,
      },
      this.handleAuthResult
    );

    setTimeout(() => {
      $('.ql-editor').click();
    }, 500);
  }

  public onPickerApiLoad() {
    this.pickerApiLoaded = true;
  }

  public handleAuthResult(authResult) {
    $('#UpFileModal').modal('hide');
    let src;

    if (authResult && !authResult.error) {
      if (authResult.access_token) {
        let view = new google.picker.View(google.picker.ViewId.DOCS);
        view.setMimeTypes(
          'application/pdf,application/txt,text/plain,application/vnd.oasis.opendocument.text,application/vnd.google-apps.document,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        );

        let pickerBuilder = new google.picker.PickerBuilder();
        let picker = pickerBuilder
          .enableFeature(google.picker.Feature.MINE_ONLY)
          .setOAuthToken(authResult.access_token)
          .addView(view)
          .addView(new google.picker.DocsUploadView())
          .setCallback(function (e) {
            if (e.action == google.picker.Action.PICKED) {
              var fileId = e.docs[0].id;
              var file = e.docs[0].url;
              var files = e.docs[0];
              if (files.sizeBytes > 5243000) {
                this.lodershow = false;

                swal({
                  background: '#FFFFFF',
                  title: 'Error',
                  html: `
                  <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                    background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                    <div class="text-center" style="margin-top: 9%;">
                      <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                      <div style="width: 323px; height: 64px; margin-left: 77px;">
                        <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                          File should be less than 5 MB
                        </p>
                      </div>
                      <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                        border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                        class="mt-4 butn-alert">Ok</button>
                    </div>
                  </div>
                `,
                  showConfirmButton: false,
                  width: '323px',
                  timer: 4000,
                });

                setTimeout(() => {
                  const okButton = document.getElementById('swal-ok-button');
                  if (okButton) {
                    okButton.addEventListener('click', () => {
                      swal.close();
                    });
                  }
                }, 0);
              } else {
                if (e.docs[0].name.split('.')[1] === 'pdf') {
                  this.loaderAlert = true;
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://drive.google.com/u/0/uc?id=' +
                    fileId +
                    '&export=download';
                  let profile_id = localStorage.getItem('profile_id');
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'pdf',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      $('.ql-editor').html(
                        return_data.RetCnt.replace(/&quot;/g, '"')
                          .replace(/&#x27;/g, "'")
                          .replace(/&amp;/g, /&/g)
                          .replace(/&gt;/g, '>')
                          .replace(/&lt;/g, '<')
                          .replace(/&quot;/g, /"/g)
                          .replace(/\n/g, '<br>')
                      );
                      this.homeText = return_data.RetCnt.replace(/\n/g, '<br>');
                      this.loaderAlert = false;

                      setTimeout(() => {
                        $('.ql-editor').click();
                      }, 500);
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
        <div class="text-center" style="margin-top: 9%;">
          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
          <div style="    width: 369px; height: 64px; margin-left: 39px;">
            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
            </p>
          </div>
          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
            class="mt-5 butn-alert">Ok</button>
        </div>
      </div>
    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                } else if (e.docs[0].name.split('.')[1] === 'txt') {
                  this.loaderAlert = true;
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://drive.google.com/u/0/uc?id=' +
                    fileId +
                    '&export=download';

                  if (localStorage.getItem('profile_id')) {
                    var profile_id = localStorage.getItem('profile_id');
                  } else {
                    var profile_id = '1';
                  }
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'txt',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      this.hideothers = true;

                      $('.ql-editor').html(
                        return_data.RetCnt.replace(/&quot;/g, '"')
                          .replace(/&#x27;/g, "'")
                          .replace(/&amp;/g, /&/g)
                          .replace(/&gt;/g, '>')
                          .replace(/&lt;/g, '<')
                          .replace(/&quot;/g, /"/g)
                          .replace(/\n/g, '<br>')
                      );
                      this.homeText = return_data.RetCnt.replace(/\n/g, '<br>');
                      this.loaderAlert = false;
                      setTimeout(() => {
                        $('.ql-editor').click();
                      }, 500);
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
        <div class="text-center" style="margin-top: 9%;">
          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
          <div style="    width: 369px; height: 64px; margin-left: 39px;">
            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
            </p>
          </div>
          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
            class="mt-5 butn-alert">Ok</button>
        </div>
      </div>
    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                } else if (e.docs[0].name) {
                  this.loaderAlert = true;
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://docs.google.com/feeds/download/documents/export/Export?id=' +
                    fileId +
                    '&exportFormat=docx';
                  let profile_id = localStorage.getItem('profile_id');
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'docx',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      $('.ql-editor').html(
                        return_data.RetCnt.replace(/&quot;/g, '"')
                          .replace(/&#x27;/g, "'")
                          .replace(/&amp;/g, /&/g)
                          .replace(/&gt;/g, '>')
                          .replace(/&lt;/g, '<')
                          .replace(/&quot;/g, /"/g)
                          .replace(/\n/g, '<br>')
                      );
                      this.homeText = return_data.RetCnt.replace(/\n/g, '<br>');
                      this.loaderAlert = false;
                      setTimeout(() => {
                        $('.ql-editor').click();
                      }, 500);
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
        <div class="text-center" style="margin-top: 9%;">
          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
          <div style="    width: 369px; height: 64px; margin-left: 39px;">
            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
            </p>
          </div>
          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
            class="mt-5 butn-alert">Ok</button>
        </div>
      </div>
    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                }
              }
            }
          })
          .build();
        picker.setVisible(true);
      }
    }
  }

  openDropboxChooser(): void {
    const options = {
      success: (files: any) => {
        let fileType = this.getFileType(files[0].name);

        if (fileType === 'docx' || fileType === 'pdf' || fileType === 'txt') {
          this.uploadFileToServer(files[0].link, fileType);
        } else {
          // console.error('Unsupported file type');
        }
      },

      cancel: () => { },
      linkType: 'direct',
      multiselect: false,
      extensions: ['.docx', '.pdf', '.txt'],
      sizeLimit: 1024 * 1024 * 5,
    };
    Dropbox.choose(options);
  }
  getFileType(fileName: string): string {
    const fileExtension = fileName.split('.').pop();
    return fileExtension ? fileExtension.toLowerCase() : '';
  }
  uploadFileToServer(fileLink: string, fileType: string): void {
    this.word_count = 0;
    this.char_count = 0;
    this.spellingmistake = 0;
    this.garmmarmistake = 0;
    this.menuafterresponse = false;
    this.showonlydrive = false;
    this.loaderAlert = true;

    const headers = new HttpHeaders({
      Authorization: environment.AuthorizationGIN,
    });
    var data = { file_type: fileType, file_path: fileLink };
    this.httpClient.dropboxfile(fileType, fileLink).subscribe((data) => {
      let receivedData = data;
      $('.ql-editor').html(
        receivedData['RetCnt']
          .replace(/&quot;/g, '"')
          .replace(/&#x27;/g, "'")
          .replace(/&amp;/g, /&/g)
          .replace(/&gt;/g, '>')
          .replace(/&lt;/g, '<')
          .replace(/&quot;/g, /"/g)
          .replace(/\n/g, '<br>')
      );
      this.getContent('', receivedData['RetCnt']);
      this.char_count = $('#editor').text().length;
      // this.homeText = $('#editor').text();
      this.word_count = $('#editor').text().split(/\s+/).length;
      this.loaderAlert = false;
    });
  }

  isCharCountTooLarge(): boolean {
    return this.char_count.toString().length >= 6;
  }
  iswordCountTooLarge(): boolean {
    return this.word_count.toString().length >= 5;
  }
  /////////// signup with google
  private initializeGoogleAuth(): Promise<void> {
    return new Promise((resolve, reject) => {
      gapi.load('auth2', () => {
        gapi.auth2
          .init({
            client_id:
              '859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com',
          })
          .then(() => {
            resolve();
          })
          .catch((error) => {
            // console.error('Error initializing Google Auth', error);
            reject(error);
          });
      });
    });
  }

  public googleLogin(): void {
    this.initializeGoogleAuth()
      .then(() => {
        const googleAuth = gapi.auth2.getAuthInstance();
        googleAuth
          .signIn({ scope: 'profile email' })
          .then((googleUser) => {
            this.onSignIn(googleUser);
          })
          .catch((error) => {
            // console.error('Google Sign-In failed', error);
          });
      })
      .catch((error) => {
        // console.error('Google API initialization failed', error);
      });
  }

  public onSignIn(googleUser): void {
    const profile = googleUser.getBasicProfile();
    const id_token = googleUser.getAuthResponse().id_token;
    const body = {
      firstname: btoa(profile.getGivenName()),
      lastname: btoa(profile.getFamilyName()),
      email: btoa(profile.getEmail()),
    };

    this.gLogin(body);
  }
  public gLogin(body): void {
    this.httpClient.signupinGoogle2(body).subscribe(
      (data) => {
        if (data.meta.code === 200) {
          localStorage.setItem('currentUser', JSON.stringify(data));
          this.user = data['response'];
          this.authentication_token = this.user['user'].authentication_token;
          this.idgoogle = this.user['user'].id;
          localStorage.setItem('fullname', this.user['user'].verify);
          localStorage.setItem(this.idgoogle, 'profile_id');

          localStorage.setItem('profile_id', this.idgoogle);
          localStorage.setItem(
            'authentication_token',
            this.user['user'].authentication_token
          );
          localStorage.setItem('token', this.user['user'].authentication_token);

          localStorage.setItem('role', '1');

          swal({
            background: '#FFFFFF',
            title: 'success',
            html: `
          <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
            background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
            <div class="text-center" style="margin-top: 9%;">
              <img src="/assets/images/paraphrasing tool/success.svg" alt="Alert" />
              <div style="    width: 369px; height: 64px; margin-left: 39px;">
                <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                You have successfully logged into GrammarIn.
                </p>
              </div>
            </div>
          </div>
        `,
            showConfirmButton: false,
            width: '323px',
            timer: 4000,
          });

          setTimeout(() => {
            const okButton = document.getElementById('swal-ok-button');
            if (okButton) {
              okButton.addEventListener('click', () => {
                swal.close();
              });
            }
          }, 0);

          this.router.navigate(['/']).then(() => {
            window.location.reload();
          });
        } else if (data.meta.code === 400) {
          swal({
            background: '#FFFFFF',
            title: 'Error',
            html: `
          <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
            background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
            <div class="text-center" style="margin-top: 9%;">
              <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
              <div style="    width: 369px; height: 64px; margin-left: 39px;">
                <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                 You have already registered your account from the web.
                </p>
              </div>
              <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                class="mt-5 butn-alert">Ok</button>
            </div>
          </div>
        `,
            showConfirmButton: false,
            width: '323px',
            timer: 4000,
          });

          setTimeout(() => {
            const okButton = document.getElementById('swal-ok-button');
            if (okButton) {
              okButton.addEventListener('click', () => {
                swal.close();
              });
            }
          }, 0);
        }
      },
      (error) => {
        // console.error('Login error', error);
      }
    );
  }
  ///// custom plan routing
  public customplans() {
    this.router.navigate(['/contact-us']);
  }
  checkUserIdAndRoute(planname, amount, price_id) {
    this.selectedplan = planname;
    this.selectedplanaoumt = amount;
    localStorage.setItem('plan', this.selectedplan);
    localStorage.setItem('amount', this.selectedplanaoumt);
    localStorage.setItem('price_id', price_id);
    this.router.navigate(['plans']);
  }
  public paymentapiforbasicplan() {
    this.price_id = 'price_1PyABECGbZSVDA9YBZv7fT5b';

    this.httpClient
      .callpaymentapi(this.profile_id, this.price_id)
      .subscribe((data) => {
        if (
          data.response ===
          'You are already subscribed. Please cancel previous subscription before getting new Subscription.'
        ) {
          this.showAlert(data.response, '');
        } else {
          window.open(data.url, '_blank');
        }
      });
  }

  showAlert(message, selector) {
    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts').show();
    setTimeout(() => {
      $('#errorAlerts').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.error = false;
    }, 4000);
  }

  showSuccess(message, selector) {
    this.successAlert = message;
    this.success = true;
    $('#successAlert').show();
    setTimeout(() => {
      $('#successAlert').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.success = false;
    }, 4000);
  }

  closeErrorDiv() {
    this.error = false;
  }

  public gcrouteto() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.router.navigate(['/grammar-checker']);
  }

  checkEmptyFieldsPhone(form) {
    let emptyFields = [];

    if (form.form_name === '') {
      emptyFields.push('form_name');
    }
    if (form.form_lastname === '') {
      emptyFields.push('form_lastname');
    }
    if (form.form_emailget === '') {
      emptyFields.push('form_emailget');
    }
    if (form.form_messageget.trim() === '') {
      emptyFields.push('form_messageget');
    }

    return emptyFields;
  }

  public eFormSubmissionGet(event: any) {
    event.preventDefault();

    const headers = new HttpHeaders({
      Authorization: environment.AuthorizationGIN,
    });
    this.https
      .post(
        environment.API_URL + '/api/contactForm',
        {
          first_name: this.form_name,
          last_name: this.form_lastname,
          email: this.form_emailget,
          subject: 'Get in Touch',
          message: this.form_messageget,
        },
        { headers }
      )
      .subscribe(
        (response) => {
          this.color = '#07BA9C';
          // this.eFsubText = 'Form Submitted Successfully!';
          this.translate
            .get('alerts.Form-Submitted')
            .subscribe((res: string) => {
              this.eFsubText = res;
            });
          this.eFsub = true;
          $('#eFsubText').show();
          setTimeout(function () {
            $('#eFsubText').hide();
            this.eFsub = false;
          }, 3000);
          $('#form_emailget').val('').css('border-color', '#e7e7ec');
          $('#form_lastname').val('').css('border-color', '#e7e7ec');
          $('#form_messageget').val('').css('border-color', '#e7e7ec');
          $('#form_name').val('').css('border-color', '#e7e7ec');
        },
        (error) => {
          // console.error(error);
        }
      );
  }

  public noerrorfound: boolean = false;

  ngAfterViewChecked() {
    this.cd.detectChanges();
  }

  ////// hidden recaptcha strat for get touch
  handleButtonClickGetTouch(): void {
    this.form_name = ($('#form_name').val() as string).trim();
    this.form_lastname = ($('#form_lastname').val() as string).trim();
    this.form_emailget = ($('#form_emailget').val() as string).trim();
    this.form_messageget = ($('#form_messageget').val() as string).trim();

    let form = {
      form_name: this.form_name,
      form_lastname: this.form_lastname,
      form_messageget: this.form_messageget,
      form_emailget: this.form_emailget,
    };

    let emptyFields = this.checkEmptyFieldsPhone(form);

    if (emptyFields.length > 0) {
      this.color = '#721c24';
      // this.eFsubText = 'Please provide the required fields';
      this.translate
        .get('alerts.required-fields')
        .subscribe((translatedText) => {
          this.eFsubText = translatedText;
        });
      emptyFields.forEach((field) => $('#' + field).css('border-color', 'red'));
      this.eFsuberror = true;
      $('#eFsubTexterror').show();

      setTimeout(() => {
        $('#eFsubTexterror').hide();
        emptyFields.forEach((field) =>
          $('#' + field).css('border-color', '#e7e7ec')
        );
        this.eFsuberror = false;
      }, 3000);
      return;
    }

    const emailPattern =
      /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (!emailPattern.test(this.form_emailget)) {
      this.color = '#721c24';
      // this.eFsubText = 'Please provide a valid email address';
      this.translate.get('alerts.valid-email').subscribe((res: string) => {
        this.eFsubText = res;
      });
      $('#form_emailget').val('').css('border-color', 'red');
      this.eFsuberror = true;
      $('#eFsubTexterror').show();

      setTimeout(() => {
        $('#eFsubTexterror').hide();
        $('#form_emailget').css('border-color', '#e7e7ec');
        this.eFsub = false;
      }, 3000);
      return;
    }

    if (this.isCaptchaVerified) {
      const dummyEvent = new Event('submit');
      this.eFormSubmissionGet(dummyEvent);
    } else {
      if (!this.captchaVisible) {
        this.captchaVisible = true;
        this.cdr.detectChanges();
        this.loadAndRenderTurnstileGetTouch();
      } else {
        this.recaptchaMessage = 'Please complete the CAPTCHA.';
        this.color = '#721c24';
      }
    }
  }
  loadAndRenderTurnstileGetTouch(): void {
    if (typeof window['turnstile'] === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => this.renderTurnstileGetTouch();
      script.onerror = () =>
        //  console.error('Failed to load Turnstile script.');
        document.body.appendChild(script);
    } else {
      this.renderTurnstileGetTouch();
    }
  }
  renderTurnstileGetTouch(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (!containerElement) {
      // console.error('Container element not found.');
      return;
    }

    window['turnstile'].render(containerElement, {
      sitekey: environment.CaptchaKey,
      size: 'normal',
      callback: (token: string) => this.onTurnstileSuccessGetTouch(token),
      'error-callback': () => this.onTurnstileErrorGetTouch(),
    });
    // console.log('Turnstile rendered successfully.');
  }
  onTurnstileSuccessGetTouch(token: string): void {
    // console.log('Turnstile token received:', token);
    this.captchaToken = token;
    this.isCaptchaVerified = true;
    this.captchaVisible = false;
    this.recaptchaMessage = '';
    const dummyEvent = new Event('submit');
    this.eFormSubmissionGet(dummyEvent);
  }
  onTurnstileErrorGetTouch(): void {
    // console.error('Turnstile error occurred.');
    this.captchaToken = null;
    this.recaptchaMessage = 'CAPTCHA verification failed. Please try again.';
    this.color = '#721c24';
  }
  resetTurnstileGetTouch(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (typeof window['turnstile'] !== 'undefined') {
      window['turnstile'].reset(containerElement);
    } else {
      // console.error('Turnstile library not loaded.');
    }
  }
  ////// hidden recaptcha strat for get touch

  //  array array array
  grammarFeatures = [
    'home.Identifies',
    'home.Spelling',
    'home.Suggest',
    'home.Punctuation',
  ];

  quillEditor: any;

  onEditorCreated(quillInstance: Quill) {
    this.quillEditor = quillInstance;
    this.homeText = this.quillEditor.root.innerHTML;
    this.char_count = this.quillEditor.getText().trim().length;
    this.word_count = this.quillEditor
      .getText()
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;
  }
  editorModules = {
    toolbar: false,

  };

  copyFormattedText() {
    const quillEditor = document.querySelector('.ql-editor');
    if (quillEditor) {
      let clonedContent = quillEditor.cloneNode(true) as HTMLElement;

      clonedContent
        .querySelectorAll('img, video, iframe')
        .forEach((el) => el.remove());

      clonedContent.querySelectorAll('*').forEach((el) => {
        if (el instanceof HTMLElement) {
          el.style.backgroundColor = '';
          el.removeAttribute('style');
        }
      });

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = clonedContent.innerHTML;
      document.body.appendChild(tempDiv);

      const range = document.createRange();
      range.selectNodeContents(tempDiv);
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(range);

      document.execCommand('copy');
      document.body.removeChild(tempDiv);
    }
  }

  quill: Quill | undefined;

  onHandleFormatting(quillInstance: Quill) {
    this.quill = quillInstance;

    this.quill.root.addEventListener('paste', (event: ClipboardEvent) => {
      event.preventDefault();

      this.showParagraph = false;

      setTimeout(() => {
        let quillContent = this.quill.root.innerHTML;

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = quillContent;

        tempDiv
          .querySelectorAll('input[type="checkbox"], input[type="radio"]')
          .forEach((input) => input.remove());
        tempDiv
          .querySelectorAll('app-icons-free-tools')
          .forEach((icon) => icon.remove());
        tempDiv
          .querySelectorAll('script, img, svg, video, iframe, embed')
          .forEach((el) => el.remove());

        tempDiv.querySelectorAll('iframe').forEach((iframe) => {
          const src = (iframe as HTMLIFrameElement).src;
          if (src.includes('youtube.com') || src.includes('youtu.be')) {
            iframe.remove();
          }
        });

        tempDiv.querySelectorAll('*').forEach((el) => {
          const element = el as HTMLElement;
          element.style.background = 'none';
          element.style.backgroundColor = 'transparent';
          element.style.color = 'black';
          element.removeAttribute('id');
          element.removeAttribute('class');
        });
        setTimeout(() => {
          tempDiv.querySelectorAll('*').forEach((el) => {
            const element = el as HTMLElement;
            element.style.background = 'none';
            element.style.backgroundColor = 'transparent';
            element.style.color = 'black';
            element.removeAttribute('id');
            element.removeAttribute('class');
          });
        }, 500);

        const emojiRegex =
          /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu;
        let modifiedContent = tempDiv.innerHTML
          .replace(emojiRegex, '')
          .replace(/\s+/g, ' ')
          .trim();

        this.quill.setContents([]);
        this.quill.clipboard.dangerouslyPasteHTML(0, modifiedContent);

        this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(
          tempDiv.innerHTML
        );

        setTimeout(() => {
          this.char_count = this.quill.getText().length;
          this.word_count = this.quill.getText().trim().split(/\s+/).length;
        }, 100);

        this.removeImagesFromQuill();
        this.handleCheckGrammarButton();

        for (let i = 0; i <= 100; i += 10) {
          setTimeout(
            () => {
              this.quill.root
                .querySelectorAll('img')
                .forEach((img) => img.remove());
            },
            i ? 5 : 0
          );
        }
      }, 0);
    });
  }

  removeImagesFromQuill() {
    setTimeout(() => {
      this.quill.root.querySelectorAll('img').forEach((img) => img.remove());
    }, 0);
  }

  sanitizedContent: SafeHtml;
  handleCheckGrammarButton() {
    this.quillEditor.root
      .querySelectorAll('img')
      .forEach((img) => img.remove());

    setTimeout(() => {
      if (this.quillEditor.root.innerText.trim().length === 0) {
        this.quillEditor.root
          .querySelectorAll('img')
          .forEach((img) => img.remove());
        this.quillEditor.enable();
        return;
      }
    }, 100);
  }
  editorFocused: boolean = false;
  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent) {
    const clickedInside = (event.target as HTMLElement).closest('.home-editor');
    this.editorFocused = !!clickedInside;
  }

  onEditorClick(event: Event) {
    this.editorFocused = true;
  }

  onBlur() {
    // Optionally check content again on blur if needed
    if (this.word_count === 0 && this.char_count === 0) {
      this.editorFocused = false;
    }
  }

  getLocalizedImagePath(imageBaseName: string): string {
    const lang = this.languageService.selectedLanguage?.code || 'en';
    return lang === 'en'
      ? `/assets/images/illustration/${imageBaseName}-${lang}.svg`
      : `/assets/images/illustration/${imageBaseName}-${lang}.svg`;
  }
}
